import { Box, Button, Divider, Grid, IconButton, Modal, Stack, Typography } from "@mui/material"
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useTranslation } from "react-i18next";
import { useForm } from "../../../hooks";
import { NumberInput } from "../NumberInput";
import { useSelector } from "react-redux";
import { converterInvestment } from "../../helpers/investments";

export const OnConvertForm = ({ style, setHidden, setReloadData }) => {

    const { t } = useTranslation('global')
    const { dataToAction } = useSelector(state => state.opportunity)

    const handleCancel = () => {
        setHidden(false)
    }

    const [formValues, handleInputChange] = useForm({ participationValuation: '' })
    const { participationValuation } = formValues

    const onSubmit = async(e) => {
        e.preventDefault()
        await converterInvestment({ participationValuation: parseFloat(participationValuation), opportunityId: dataToAction.id }, t('opportunities.successMsgConvert'), t('opportunities.errorMsg'))
        setHidden(false)
        setReloadData(prevState => !prevState)
    }

    return (
        <Modal
            open={true}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ zIndex: 9999 }}
        >
            <Box sx={style}>
                <Stack direction='row' justifyContent='space-between' alignItems='baseline' sx={{ height: '50px' }}>
                    <Typography color='primary' marginBottom='10px' variant='h5' fontWeight={700}>{t('opportunities.converter')}</Typography>
                    <IconButton color='primary' onClick={handleCancel}>
                        <CloseRoundedIcon />
                    </IconButton>
                </Stack>
                <form onSubmit={onSubmit} style={{ padding: '10px 5px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                    <Stack sx={{ height: 'calc(70vh - 200px)', overflowY: 'auto', paddingBottom: '50px', paddingRight: '20px' }}>


                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <NumberInput translation='addevent' name={participationValuation} title='participationValuation' handleInputChange={handleInputChange} required={true} />
                            </Grid>
                        </Grid>

                        <Grid container direction='row' width='100%' textAlign='center' marginTop={3}>
                            <Grid item xs={12} padding='0 5px'>
                                <Typography color='secondary' marginBottom='10px' variant='body2' fontWeight={700}> * El préstamo convertible cambiará a ampliación de capital</Typography>
                            </Grid>
                        </Grid>
                    </Stack>

                    <Stack sx={{ heigth: '80px' }}>
                        <Divider sx={{ margin: '30px 0px 15px 0px' }} />

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} md={6} padding='0 5px'>
                                <Button fullWidth onClick={handleCancel} variant="text">{t("createPassword.cancelButton")}</Button>
                            </Grid>
                            <Grid item xs={12} md={6} padding='0 5px'>
                                <Button fullWidth type='submit' variant="contained">{t("createPassword.principalButton")}</Button>
                            </Grid>
                        </Grid>
                    </Stack>
                </form>
            </Box>
        </Modal>
    )
}
